import { render, staticRenderFns } from "./orderProductionPreview.vue?vue&type=template&id=0b909daa&scoped=true&"
import script from "./orderProductionPreview.vue?vue&type=script&lang=js&"
export * from "./orderProductionPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b909daa",
  null
  
)

export default component.exports